module.exports = __WEBPACK_EXTERNAL_MODULE_201__;


//////////////////
// WEBPACK FOOTER
// external "xes-frontend-ui/lib/material-filter"
// module id = 201
// module chunks = 11